import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    termsContainer: {
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: 1.6,
    },
    termsTitle: {
        fontSize: '2.5em',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#1b2a4e',
        marginBottom: '30px',
    },
    termsSection: {
        marginBottom: '30px',
    },
    appNotice: {
        backgroundColor: '#f4f7f9',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '5px solid #1b2a4e',
        marginBottom: '30px',
    },
    termsSubtitle: {
        fontSize: '1.5em',
        fontWeight: 'bold',
        color: '#1b2a4e',
        marginBottom: '10px',
    },
    termsText: {
        margin: '5px 0',
        textAlign: 'justify',
    },
    indent: {
        marginLeft: '1rem',
        display: 'block'
    },
});

const PrivacyPolicyCA: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.termsContainer}>
            <h1 className={classes.termsTitle}>Política de Privacitat</h1>

            <section className={classes.appNotice}>
                <h2 className={classes.termsSubtitle}>Adenda: Ús de Dades a l'Aplicació Mòbil</h2>
                <p className={classes.termsText}>
                    En el marc de la col·laboració clínica amb el <b>Parc Taulí</b> per a l'estudi i tractament de la depressió, l'aplicació mòbil de DigimEvo requereix el tractament de dades específiques per habilitar les seves funcions assistencials:
                </p>
                <p className={classes.termsText}>
                    <span className={classes.indent}>
                        • <b>Ubicació en segon pla:</b> Recollim dades de localització exacta (GPS/Geofencing) fins i tot quan l'aplicació està tancada o no s'està utilitzant. Aquestes dades s'utilitzen exclusivament per monitorar la mobilitat del pacient i detectar indicadors clínics d'anhedonia o aïllament social, permetent alertes primerenques al personal mèdic.
                    </span>
                    <span className={classes.indent}>
                        • <b>Accés a l'ús del dispositiu:</b> Monitoritzem patrons d'ús d'aplicacions instal·lades per avaluar el benestar digital del pacient com a biomarcador del seu estat anímic.
                    </span>
                    <span className={classes.indent}>
                        • <b>Transferència a tercers:</b> Les dades esmentades són processades per DigimEvo i transferides als nostres socis tecnològics col·laboradors (incloent-hi <b>Evidenze</b>) sota estrictes protocols de seguretat i anonimització, amb l'única finalitat de proporcionar estadístiques clíniques al facultatiu responsable.
                    </span>
                </p>
            </section>

            <p className={classes.termsText}>
                DigimEvo es pren molt seriosament la seva privacitat i tracta totes les seves dades personals amb molta cura. Aquest document estableix la política de DigimEvo pel que fa a la privacitat i la seguretat. Es recomana que llegeixi aquesta política amb atenció. Les paraules en majúscula es defineixen en els Termes de Servei.
            </p>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>1. Qui és DigimEvo?</h2>
                <p className={classes.termsText}>
                    DigimEvo Limited és una societat de responsabilitat limitada constituïda i existent sota les lleis d'Espanya, amb seu social a Travessera de les Corts 262, 12 2, Barcelona 08014.
                </p>
                <p className={classes.termsText}>
                    DigimEvo ha desenvolupat una plataforma utilitzada pels proveïdors sanitaris per recollir informació dels seus pacients i/o proporcionar informació als seus pacients. DigimEvo no és un proveïdor d'atenció mèdica i no filtra el contingut publicat pels proveïdors d'atenció mèdica, ni selecciona ni filtra informació específica que es mostra als pacients.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>2. Llei Aplicable</h2>
                <p className={classes.termsText}>
                    DigimEvo Limited, com a empresa constituïda a Espanya, està subjecta a la Llei de Protecció de Dades de 2018, al Reglament (UE) 679/2016 (GDPR) i al Reglament de Privacitat i Comunicacions Electròniques de 2011 quan controla o processa dades en el seu negoci.
                </p>
                <p className={classes.termsText}>
                    No obstant això, el lloc on viu i el lloc on s'ha constituït el seu proveïdor de salut poden afectar les lleis de privacitat i protecció de dades que s'apliquen al control o processament de les seves dades.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>3. DigimEvo com a Processador de Dades</h2>
                <p className={classes.termsText}>
                    DigimEvo emmagatzemarà i processarà dades personals en nom dels seus clients, els proveïdors d'atenció mèdica. Per a aquest processament, el proveïdor d'atenció mèdica actuarà com a "responsable de les dades" en el sentit de la Llei de Protecció de Dades de 2018 i el Reglament (UE) 679/2016 (GDPR).
                </p>
                <p className={classes.termsText}>
                    DigimEvo també actua de vegades com a processador de dades quan és responsable del processament legal de dades personals. Els motius legals pels quals processem les dades personals poden variar segons els termes del nostre negoci, però en general ens basem en una varietat de bases legals per processar, incloent-hi el contracte, el consentiment i l'expectativa legítima. Si us plau, consulti el seu proveïdor d'atenció mèdica, el responsable de les dades, per entendre com poden processar les seves dades personals i els termes de les seves polítiques de privacitat.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>4. DigimEvo com a Responsable de Dades</h2>
                <p className={classes.termsText}>
                    En determinades circumstàncies, DigimEvo també pot processar les seves dades personals per als seus propis fins, en aquest cas DigimEvo serà el "responsable de les dades" de les seves dades personals i responsable del processament legal d'aquestes dades personals. Pot oposar-se al processament de les seves dades; no obstant això, això pot impedir-nos proporcionar-li els nostres serveis. Si us plau, posi's en contacte amb nosaltres utilitzant les dades de contacte que es detallen a continuació si desitja que deixem de processar les seves dades.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>5. Quines Dades Personals Recull i Processa DigimEvo?</h2>
                <p className={classes.termsText}>
                    Per utilitzar el Servei, cal crear un compte personal. Per a això, ha d'introduir certa informació sobre vostè. El seu nom, gènere i adreça de correu electrònic són obligatoris; altres camps són opcionals, com el número de telèfon o el país de residència.
                </p>
                <p className={classes.termsText}>
                    La informació continguda en el seu compte no és visible per a tercers. Per als pacients, només el proveïdor d'atenció mèdica autoritzat pel pacient pot veure la informació del seu compte.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>6. Termes del Servei</h2>
                <p className={classes.termsText}>
                    En utilitzar el Servei, el proveïdor d'atenció mèdica comparteix informació educativa mitjançant una prescripció de vídeo amb els pacients, i els pacients proporcionen comentaris al respecte. Aquesta informació és privada entre el pacient i el proveïdor d'atenció mèdica i només és accessible si el pacient autoritza el proveïdor d'atenció mèdica a accedir a les dades.
                </p>
                <p className={classes.termsText}>
                    DigimEvo emmagatzema aquesta informació en nom del proveïdor d'atenció mèdica. DigimEvo només processarà la informació del pacient per als seus propis fins amb el consentiment del pacient. Un cop el pacient hagi donat el consentiment, DigimEvo anonimitzarà la informació del pacient i la compartirà amb tercers autoritzats.
                </p>
                <p className={classes.termsText}>
                    Si el pacient és menor d'edat, es demanarà als pares o tutors legals del pacient que donin el seu consentiment per al processament descrit anteriorment.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>7. Cookies</h2>
                <p className={classes.termsText}>
                    Quan utilitza DigimEvo, es guarden cookies al seu ordinador. Les cookies són petits fragments d'informació (en forma de text) que un servidor envia al seu navegador (com Internet Explorer o Firefox) amb la intenció que el navegador enviï aquesta informació al servidor la propera vegada que un usuari faci ús del Servei. Les cookies no poden danyar el seu ordinador ni els arxius que hi estan desats.
                </p>
                <p className={classes.termsText}>
                    Quan utilitza el Servei, les cookies de primera part es guarden al seu ordinador. Les cookies de primera part són creades per o per a DigimEvo, i DigimEvo les emmagatzema al seu ordinador, i només DigimEvo té accés a aquestes cookies. DigimEvo utilitza aquestes cookies, per exemple, per recordar la seva informació d'inici de sessió.
                </p>
                <p className={classes.termsText}>
                    Per recopilar dades sobre l'ús del lloc web de DigimEvo (el lloc web de màrqueting, no la plataforma utilitzada per accedir al Servei), DigimEvo utilitza Google Analytics. Google Analytics emmagatzema una cookie persistent al seu ordinador, que posteriorment s'utilitza per registrar l'ús que fa del lloc web. A continuació, Google analitza aquestes dades i els resultats es proporcionen a DigimEvo. Això permet a DigimEvo millorar els seus serveis als clients i visitants del lloc web.
                </p>
                <p className={classes.termsText}>
                    Pot configurar el seu navegador perquè no rebi cookies la propera vegada que utilitzi el Servei. No obstant això, és possible que ja no pugui fer un ús complet del lloc web de DigimEvo o dels serveis d'inici de sessió del portal que s'ofereixen en línia.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>8. Fins per Als Quals DigimEvo Processa les Dades Personals</h2>
                <p className={classes.termsText}>
                    DigimEvo pot utilitzar les seves dades personals per als següents fins:
                    <br />
                    <span className={classes.indent}>
                        - Permetre que el proveïdor d'atenció mèdica utilitzi el Servei, inclosa la gestió dels programes de prescripció de vídeo per als pacients, la gestió del compliment dels pacients amb els programes de prescripció de vídeo i l'intercanvi de plantilles de programes de prescripció de vídeo amb altres usuaris de DigimEvo.
                    </span>
                    <span className={classes.indent}>
                        - Permetre que el pacient utilitzi el Servei, inclòs l'accés als programes de prescripció de vídeo a casa proporcionats pel proveïdor d'atenció mèdica, controlar el compliment i proporcionar comentaris al proveïdor d'atenció mèdica.
                    </span>
                    <span className={classes.indent}>
                        - Comunicar-nos amb vostè sobre el Servei i/o altres serveis de DigimEvo.
                    </span>
                    <span className={classes.indent}>
                        - Configurar DigimEvo per al seu ús.
                    </span>
                    <span className={classes.indent}>
                        - Amb fins de protecció i per generar dades estadístiques anònimes.
                    </span>
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>9. Compartició de Dades</h2>
                <p className={classes.termsText}>
                    DigimEvo només divulgarà informació mèdica a tercers quan el proveïdor d'atenció mèdica hagi donat el seu consentiment perquè el tercer específic involucrat (per exemple, una companyia d'assegurances) rebi aquesta informació i si aquesta informació és anònima per protegir la privacitat del pacient.
                    <br />
                    DigimEvo només proporcionarà les seves dades personals a tercers diferents dels establerts en aquesta Política de Privacitat en els següents casos:
                    <br />
                    <span className={classes.indent}>
                        - Si està obligat a fer-ho en base a l'acord amb el proveïdor d'atenció mèdica.
                    </span>
                    <span className={classes.indent}>
                        - Si està obligat a fer-ho en virtut de lleis, jurisprudència i/o regulacions nacionals o internacionals.
                    </span>
                    <span className={classes.indent}>
                        - Si DigimEvo ho considera necessari per defensar els seus propis drets.
                    </span>
                    <span className={classes.indent}>
                        - Si ha donat permís per fer-ho.
                    </span>
                    <br />
                    DigimEvo pot publicar testimonis, comentaris o ressenyes de clients al lloc web, que poden contenir dades personals de proveïdors d'atenció mèdica. DigimEvo obtindrà el consentiment del proveïdor d'atenció mèdica per correu electrònic abans de publicar el testimoni.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>10. Transferències Internacionals de Dades</h2>
                <p className={classes.termsText}>
                    Com que DigimEvo utilitza servidors localitzats per emmagatzemar les seves dades personals, això minimitza les transferències de dades a països que poden no proporcionar una protecció adequada per llei a les seves dades personals. Per obtenir una llista completa dels països aprovats per la Comissió Europea com a "adequats", faci clic aquí: https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/adequacy-protection-personal-data-non-eu-countries_en
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>11. Processament de Dades de Comportament</h2>
                <p className={classes.termsText}>
                    DigimEvo utilitza serveis d'anàlisi de tercers per ajudar a comprendre l'ús del Servei per part dels proveïdors d'atenció mèdica. No es comparteix informació del pacient a través d'aquests serveis.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>12. Retenció de Dades</h2>
                <p className={classes.termsText}>
                    Totes les dades processades per DigimEvo es conservaran durant períodes d'acord amb la Política de Retenció de Dades. Quan un proveïdor de salut cancel·la el servei de DigimEvo, les dades personals emmagatzemades es suprimiran o es conservaran d'acord amb la Política de Retenció de Dades de DigimEvo.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>13. Seguretat de les Dades</h2>
                <p className={classes.termsText}>
                    DigimEvo pren les mesures tècniques i organitzatives adequades per protegir les seves dades personals contra la pèrdua o qualsevol forma d'ús il·legal. A causa de la naturalesa mèdica d'algunes de les dades personals, DigimEvo ha incorporat un nivell de seguretat molt alt.
                </p>
                <p className={classes.termsText}>
                    Per protegir la confidencialitat i integritat de les seves dades personals, comptem amb:
                    <br />
                    <span className={classes.indent}>- Polítiques internes que mantenen les seves dades privades i confidencials.</span>
                    <span className={classes.indent}>- Xifrat de totes les comunicacions entre DigimEvo i els nostres usuaris (http mitjançant SSL, correu electrònic mitjançant TLS).</span>
                    <span className={classes.indent}>- Xifrat de tota la informació de salut del pacient a la nostra base de dades ("en repòs").</span>
                    <span className={classes.indent}>- Limitació de l'accés a la informació dins de la nostra empresa al mínim necessari.</span>
                    <span className={classes.indent}>- Ús d'un centre de dades protegit electrònicament i físicament.</span>
                    <span className={classes.indent}>- Ús d'un tallafoc que bloquegi l'accés d'atacants i usuaris no autoritzats.</span>
                    <span className={classes.indent}>- Tancament automàtic de sessió dels proveïdors d'atenció mèdica després d'un cert període d'inactivitat.</span>
                    <span className={classes.indent}>- Exigir a tots els nostres usuaris que triïn contrasenyes segures.</span>
                    <span className={classes.indent}>- Ús d'una CDN (xarxa de distribució de contingut) de classe mundial que filtra possibles atacants.</span>
                    <span className={classes.indent}>- Ús de sistemes de prova i desenvolupament d'última generació.</span>
                    <span className={classes.indent}>- Ús de les millors tecnologies de gestió de servidors de la seva classe.</span>
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>14. El Seu Dret a Accedir o Suprimir les Seves Dades Personals</h2>
                <p className={classes.termsText}>
                    Si desitja accedir a les seves dades personals que DigimEvo pugui haver emmagatzemat, o si desitja sol·licitar una còpia d'aquestes dades, o canviar dades que no pot modificar vostè mateix en el seu compte, pot enviar la seva sol·licitud a gdpr@digimevo.com. DigimEvo li proporcionarà les dades personals en un termini de 4 setmanes. Si, per alguna raó, DigimEvo no pot satisfer la seva sol·licitud, se li informarà el més aviat possible.
                </p>
                <p className={classes.termsText}>
                    DigimEvo conservarà les seves dades personals mentre el seu compte estigui actiu o segons sigui necessari per proporcionar-li el Servei, resoldre disputes, fer complir acords o complir amb qualsevol obligació legal d'acord amb la Política de Retenció de Dades. Si desitja suprimir el seu compte o sol·licitar que DigimEvo ja no utilitzi les seves dades personals, pot posar-se en contacte amb nosaltres a gdpr@digimevo.com. Les sol·licituds de retenció i eliminació de dades de DigimEvo estan subjectes a la llei, la defensa de reclamacions legals o obligacions legals independentment de la Política de Retenció de Dades.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>15. Autoritat Supervisora Correspondent</h2>
                <p className={classes.termsText}>
                    Si té una queixa sobre la forma en què es controlen o processen les seves dades, primer s'ha de posar en contacte amb el seu proveïdor de salut. Si creu que això no resol les seves inquietuds sobre la forma en què es controlen o processen les seves dades, té dret a presentar una queixa davant l'autoritat nacional de supervisió del seu país.
                </p>
                <p className={classes.termsText}>
                    Tot i que DigimEvo aplica la llei espanyola a causa de la seva constitució, la llista completa d'organismes de supervisió europeus es pot trobar aquí: https://edpb.europa.eu/about-edpb/board/members_en
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>16. Data de la Política</h2>
                <p className={classes.termsText}>
                    Aquesta política està subjecta a una revisió anual o sempre que hi hagi canvis en la llei de protecció de dades i/o privacitat. Per tant, aquesta política es modificarà en el futur. Qualsevol canvi a la política es publicarà al lloc web de DigimEvo. Aquesta política es va actualitzar per última vegada el 9 de març de 2026.
                </p>
            </section>

            <section className={classes.termsSection}>
                <h2 className={classes.termsSubtitle}>17. Dades de Contacte</h2>
                <p className={classes.termsText}>
                    Si té alguna pregunta, no dubti a posar-se en contacte amb el nostre responsable de protecció de dades a través de gdpr@digimevo.com o a Travessera de les Corts 262, 12 2, esc B, 08014 Barcelona.
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicyCA;